import { render, staticRenderFns } from "./IgManageMapping.vue?vue&type=template&id=d4d81dfa&"
import script from "./IgManageMapping.vue?vue&type=script&lang=js&"
export * from "./IgManageMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports